import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Root from './Root';
import SpatialIndex from '../SpatialIndex';
import ArrayList from '../../../../../java/util/ArrayList';
import ArrayListVisitor from '../ArrayListVisitor';
import Serializable from '../../../../../java/io/Serializable';
import Envelope from '../../geom/Envelope';
var Quadtree = /*#__PURE__*/function () {
  function Quadtree() {
    _classCallCheck(this, Quadtree);
    Quadtree.constructor_.apply(this, arguments);
  }
  _createClass(Quadtree, [{
    key: "size",
    value: function size() {
      if (this._root !== null) return this._root.size();
      return 0;
    }
  }, {
    key: "insert",
    value: function insert(itemEnv, item) {
      this.collectStats(itemEnv);
      var insertEnv = Quadtree.ensureExtent(itemEnv, this._minExtent);
      this._root.insert(insertEnv, item);
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 1) {
        var searchEnv = arguments[0];
        var visitor = new ArrayListVisitor();
        this.query(searchEnv, visitor);
        return visitor.getItems();
      } else if (arguments.length === 2) {
        var _searchEnv = arguments[0],
          _visitor = arguments[1];
        this._root.visit(_searchEnv, _visitor);
      }
    }
  }, {
    key: "queryAll",
    value: function queryAll() {
      var foundItems = new ArrayList();
      this._root.addAllItems(foundItems);
      return foundItems;
    }
  }, {
    key: "remove",
    value: function remove(itemEnv, item) {
      var posEnv = Quadtree.ensureExtent(itemEnv, this._minExtent);
      return this._root.remove(posEnv, item);
    }
  }, {
    key: "collectStats",
    value: function collectStats(itemEnv) {
      var delX = itemEnv.getWidth();
      if (delX < this._minExtent && delX > 0.0) this._minExtent = delX;
      var delY = itemEnv.getHeight();
      if (delY < this._minExtent && delY > 0.0) this._minExtent = delY;
    }
  }, {
    key: "depth",
    value: function depth() {
      if (this._root !== null) return this._root.depth();
      return 0;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      if (this._root === null) return true;
      return this._root.isEmpty();
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [SpatialIndex, Serializable];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._root = null;
      this._minExtent = 1.0;
      this._root = new Root();
    }
  }, {
    key: "ensureExtent",
    value: function ensureExtent(itemEnv, minExtent) {
      var minx = itemEnv.getMinX();
      var maxx = itemEnv.getMaxX();
      var miny = itemEnv.getMinY();
      var maxy = itemEnv.getMaxY();
      if (minx !== maxx && miny !== maxy) return itemEnv;
      if (minx === maxx) {
        minx = minx - minExtent / 2.0;
        maxx = maxx + minExtent / 2.0;
      }
      if (miny === maxy) {
        miny = miny - minExtent / 2.0;
        maxy = maxy + minExtent / 2.0;
      }
      return new Envelope(minx, maxx, miny, maxy);
    }
  }]);
  return Quadtree;
}();
export { Quadtree as default };